<!--
 * @Author: your name
 * @Date: 2022-02-11 14:10:04
 * @LastEditTime: 2022-06-28 10:59:05
 * @LastEditors: zdx 3539255028@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\views\modules\workbench\project\index.vue
-->
<template>
  <a-layout class="main">
    <!-- <a-layout-header>
      header
    </a-layout-header> -->
    <a-layout>
      <template v-if="device === 'desktop'">
        <a-layout-sider>
          <catelog />
        </a-layout-sider>
      </template>

      <a-layout-content>
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import catelog from './catelog'
import { mixinDevice } from '@/utils/mixin.js'

export default {
  name: 'Workbench',
  mixins: [mixinDevice],
  data() {
    return {}
  },
  components: {
    catelog,
  },
}
</script>
<style lang="less">
@import './index.less';
</style>
